export default __webpack_public_path__ + "static/media/notes.d9c752cb.svg";